import { Date as dateType } from '@finley-technologies/finley-types';

export enum DayOfTheWeek {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export const selectedDaysOfTheWeekToLabelMap: Record<DayOfTheWeek, string> = {
  Monday: 'M',
  Tuesday: 'Tu',
  Wednesday: 'W',
  Thursday: 'Th',
  Friday: 'F',
  Saturday: 'Sa',
  Sunday: 'Su',
};

export const dayOfTheWeekToNumberMap: Record<DayOfTheWeek, dateType.Weekday> = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 7,
};

export const numberToDayOfTheWeekMap: Record<dateType.Weekday, DayOfTheWeek> = {
  1: DayOfTheWeek.Monday,
  2: DayOfTheWeek.Tuesday,
  3: DayOfTheWeek.Wednesday,
  4: DayOfTheWeek.Thursday,
  5: DayOfTheWeek.Friday,
  6: DayOfTheWeek.Saturday,
  7: DayOfTheWeek.Sunday,
};

export interface ConfigFormState {
  isValid: boolean;
  isRelative: boolean;
  touched: boolean;
  startDate?: Date;
  endDate?: Date;
  startDateFormula?: string;
  endDateFormula?: string;
  frequency?:
    | dateType.RecurringDate.FrequencyPeriod
    | dateType.RecurringDate.ReccuringFrequencyPeriod;
  cadence?: number;
  occurrence?: number;
  period?: dateType.RecurringDate.BaseDateConfigType;
  offsetDays?: number;
  offsetDayUnit?: dateType.DayUnit;
  offsetNonBusinessDayAdjustment?: dateType.NonBusinessDayAdjustment;
  selectedDays?: DayOfTheWeek[];
}

export const FREQUENCY = ['week', 'month', 'quarter', 'year'];

export const PERIOD_OPTIONS = [
  {
    label: 'Same as start day',
    value: 'calendarDate',
  },
  {
    label: 'Start of period',
    value: 'startOf',
  },
  {
    label: 'End of period',
    value: 'endOf',
  },
  {
    label: 'Weekdays',
    value: 'weekday',
  },
  {
    label: 'Weekdays by occurrence',
    value: 'weekdayByOccurrence',
  },
];

export const OFFSET_DAY_UNIT_OPTIONS: {
  label: string;
  value: dateType.DayUnit;
}[] = [
  {
    label: 'calendar days',
    value: 'calendarDay',
  },
  {
    label: 'business days',
    value: 'businessDay',
  },
];
